import { initializeApp } from "firebase/app";
import {
  doc,
  getFirestore,
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  arrayUnion,
  arrayRemove,
  writeBatch,
} from "firebase/firestore";
import EquipoStore from "./store/index";
import store from "./store/store";
// import * as dotenv from 'dotenv'
// dotenv.config()
console.log(process.env);
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
// Follow this pattern to import other Firebase services
// import { } from 'firebase/<service>';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDh04dgT_jTuelI4xJ3QDSDrReT85t3Fg4",
  authDomain: "optix-82ca7.firebaseapp.com",
  projectId: "optix-82ca7",
  storageBucket: "optix-82ca7.appspot.com",
  messagingSenderId: "872082017793",
  appId: "1:872082017793:web:4050ccb1a1e0199161fa00",
  measurementId: "G-YKX0Z4W96X",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Get a list of cities from your database

// Crud methods for Optix
//getAll
export const getAllOptix = async () => {
  const querySnapshot = await getDocs(collection(db, "optix"));
  // querySnapshot.forEach((doc) => {
  //   console.log(`${doc.id} => ${doc.data()}`);
  // });
  const optixList = querySnapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
  // EquipoStore.data.optixList = optixList
  store.state.optixData = optixList;
  console.log("lista: ", store.state.optixData);
  console.log("lista Optix STORE: ", EquipoStore.data.optixList);
  return optixList;
};

//Create
const dbRef = collection(db, "optix");
const dataOptix = store.state.optix;

export const addOptix = async () => {
  // Add the document to the database and get a reference to it
  let docRef = await addDoc(dbRef, ...dataOptix);

  // Get the ID of the new document
  let docId = docRef.id;

  // Update the document with the ID
  let docR = doc(dbRef, docId);
  await updateDoc(docR, { id: docId });

  // console.log("Document written with ID: ", docId);
};

//Update
export const updateOptix = async (docId) => {
  try {
    console.log("Updating", dataOptix);
    let docRef = doc(dbRef, docId);
    await updateDoc(docRef, ...dataOptix);
  } catch (error) {
    console.error("Error updating document: ", error);
  }
};
//Delete
export const deleteOptix = async (docId) => {
  try {
    let docRef = doc(dbRef, docId);
    await deleteDoc(docRef);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

// Crud methods for Users
//GetAll

export const getAlluser = async () => {
  const querySnapshot = await getDocs(collection(db, "usuarios"));
  querySnapshot.forEach((doc) => {
    console.log(`${doc.id} => ${doc.data()}`);
  });
  const usuariosList = querySnapshot.docs.map((doc) => doc.data());
  // EquipoStore.data.usuariosList = usuariosList.map(object => object.nombre);
  // store.state.usersList = usuariosList.map(object => object.nombre);
  // EquipoStore.data.usuariosObject = usuariosList
  const tecnicos = usuariosList.filter((usuario) => usuario.rol === "Técnico");
  console.log(tecnicos); // Imprime un array con los objetos que tienen la propiedad rol con el valor Técnico.
  console.log(usuariosList);
  store.state.usersList = usuariosList.map((object) => ({
    nombre: object.nombre,
    id: object.id,
  }));
  store.state.tecnicosName = tecnicos.map((object) => ({
    nombre: object.nombre,
    id: object.id,
  }));

  store.state.users = usuariosList;
  console.log("lista usuariosstore: ", store.state.users);
  console.log("lista de usuarios: ", store.state.usersList);
  return usuariosList;
};

const dbRef2 = collection(db, "usuarios");
const user = store.state.newuser;

//create

export const addUser = async () => {
  // Add the document to the database and get a reference to it
  let docRef = await addDoc(dbRef2, ...user);

  // Get the ID of the new document
  const docId = docRef.id;
  store.state.idnewuser = docId;
  // Update the document with the ID
  let docR = doc(dbRef2, docId);
  await updateDoc(docR, { id: docId });

  console.log("Document written with ID: ", docId);
};

//update
export const updateUser = async (docId) => {
  try {
    let docRef = doc(dbRef2, docId);
    await updateDoc(docRef, ...user);
  } catch (error) {
    console.error("Error updating document: ", error);
  }
};
// const newdata = store.state.newdata
export const updateArray = async (docId, prop, data) => {
  try {
    let docRef = doc(dbRef2, docId);
    let newdata = { [prop]: arrayUnion(data) };
    await updateDoc(docRef, newdata);
  } catch (error) {
    console.error("Error updating document: ", error);
  }
};
//delete array
export const deleteArray = async (docId, prop, data) => {
  try {
    let docRef = doc(dbRef2, docId);
    let newdata = { [prop]: arrayRemove(data) };
    await updateDoc(docRef, newdata);
  } catch (error) {
    console.error("Error updating document: ", error);
  }
};
//Delete
export const deleteUser = async (docId) => {
  try {
    let docRef = doc(dbRef2, docId);
    await deleteDoc(docRef, ...user);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

//CRUD Westnet
//GetAll

export const getAllWestnet = async () => {
  const querySnapshot = await getDocs(collection(db, "westnet"));
  // querySnapshot.forEach((doc) => {
  //   console.log(`${doc.id} => ${doc.data()}`);
  // });
  const westnetList = querySnapshot.docs.map((doc) => doc.data());
  store.state.westnetData = westnetList;

  console.log("lista: ", westnetList);
  console.log("lista Westnet STORE: ", store.state.westnetData);
  return westnetList;
};

//Create
const dbRef3 = collection(db, "westnet");
const dataWestnet = store.state.westnet;

export const addWestnet = async () => {
  // await addDoc(dbRef3, ...dataWestnet);
  // console.log("Document written with ID: ", dbRef3.id);

  // Add the document to the database and get a reference to it
  let docRef = await addDoc(dbRef3, ...dataWestnet);

  // Get the ID of the new document
  const docId = docRef.id;
  // Update the document with the ID
  let docR = doc(dbRef3, docId);
  await updateDoc(docR, { id: docId });
  // console.log("Document written with ID: ", docId);
};
//update
export const updateWestnet = async (docId) => {
  try {
    let docRef = doc(dbRef3, docId);
    await updateDoc(docRef, ...dataWestnet);
  } catch (error) {
    console.error("Error updating document: ", error);
  }
};

//Delete
export const deleteWestnet = async (docId) => {
  try {
    let docRef = doc(dbRef3, docId);
    await deleteDoc(docRef, ...dataWestnet);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

//CRUD BIGWAY
// GetAll

export const getAllBitway = async () => {
  const querySnapshot = await getDocs(collection(db, "bitway"));
  // querySnapshot.forEach((doc) => {
  //   console.log(`${doc.id} => ${doc.data()}`);
  // });
  const bitwayList = querySnapshot.docs.map((doc) => doc.data());
  store.state.bigwayData = bitwayList;

  // console.log("lista: ", bitwayList);
  // console.log("lista Bitway STORE: ", store.state.bigwayData);
  return bitwayList;
};
//Create
const dbRef4 = collection(db, "bitway");
const dataBitway = store.state.bigway;

export const addBitway = async () => {
  // await addDoc(dbRef4, ...dataBitway);
  // console.log("Document written with ID: ", dbRef4.id);
  // EquipoStore.data.bitway[0].id = dbRef4.id
  // Add the document to the database and get a reference to it
  let docRef = await addDoc(dbRef4, ...dataBitway);

  // Get the ID of the new document
  const docId = docRef.id;

  // Update the document with the ID
  let docR = doc(dbRef4, docId);
  await updateDoc(docR, { id: docId });

  console.log("Document written with ID: ", docId);
};
//Update
//update
export const updateBitway = async (docId) => {
  try {
    let docRef = doc(dbRef4, docId);
    await updateDoc(docRef, ...dataBitway);
  } catch (error) {
    console.error("Error updating document: ", error);
  }
};

//Delete
export const deleteBitway = async (docId) => {
  try {
    let docRef = doc(dbRef4, docId);
    await deleteDoc(docRef, ...dataBitway);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

//Crud Tecnicos
//GetAll
export const getAllTecnicos = async () => {
  const querySnapshot = await getDocs(collection(db, "tecnicos"));
  querySnapshot.forEach((doc) => {
    console.log(`${doc.id} => ${doc.data()}`);
  });
  const tecnicosList = querySnapshot.docs.map((doc) => doc.data());
  store.state.tecnicoList = tecnicosList;

  // console.log("lista: ",tecnicosList);
  // console.log("lista Tecnicos STORE: ", EquipoStore.data.tecnicosList );
  return tecnicosList;
};
//Create
const dbRef5 = collection(db, "tecnicos");
const dataTecnicos = store.state.tecnico;

export const addTecnico = async () => {
  // await addDoc(dbRef5, ...dataTecnicos);
  // console.log("Document written with ID: ", dbRef5.id);
  let docRef = await addDoc(dbRef5, ...dataTecnicos);

  // Get the ID of the new document
  const docId = docRef.id;
  store.state.idtecnico = docId;
  // Update the document with the ID
  let docR = doc(dbRef5, docId);
  await updateDoc(docR, { id: docId });

  console.log("Document written with ID: ", docId);
};

//Update
export const updateTecnicos = async (docId) => {
  try {
    let docRef = doc(dbRef5, docId);
    await updateDoc(docRef, ...dataTecnicos);
  } catch (error) {
    console.error("Error updating document: ", error);
  }
};

//Delete
export const deleteTecnicos = async (docId) => {
  try {
    let docRef = doc(dbRef5, docId);
    await deleteDoc(docRef, ...dataTecnicos);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

//CRUD Totales
//GetAll

export const getAllTotales = async () => {
  const querySnapshot = await getDocs(collection(db, "totales"));
  querySnapshot.forEach((doc) => {
    console.log(`${doc.id} => ${doc.data()}`);
  });
  const totalesList = querySnapshot.docs.map((doc) => doc.data());
  EquipoStore.data.totalesList = totalesList;

  console.log("lista: ", totalesList);
  console.log("lista Totales STORE: ", EquipoStore.data.totalesList);
  return totalesList;
};

//Create

const dbRef6 = collection(db, "totales");
const dataTotales = EquipoStore.data.totales;

export const addTotales = async () => {
  let docRef = await addDoc(dbRef6, ...dataTotales);

  // Get the ID of the new document
  const docId = docRef.id;

  // Update the document with the ID
  let docR = doc(dbRef6, docId);
  await updateDoc(docR, { id: docId });

  console.log("Document written with ID: ", docId);
};

//Update
export const updateTotales = async (docId) => {
  try {
    let docRef = doc(dbRef6, docId);
    await updateDoc(docRef, ...dataTotales);
  } catch (error) {
    console.error("Error updating document: ", error);
  }
};

//Delete
export const deleteTotales = async (docId) => {
  try {
    let docRef = doc(dbRef6, docId);
    await deleteDoc(docRef, ...dataTotales);
  } catch (error) {
    console.error("Error deleting document: ", error);
  }
};

//firebase authtentication
// registrar nuevos usuarios
const auth = getAuth();
export const register = (email, password) => {
  createUserWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      console.log("User: ", user);
      console.log("Successfully registered!");
      // ...
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log("Error: ", errorCode, errorMessage);
      // ..
    });
};

//iniciar sesión usuarios existentes

export const loginFirebase = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const signOutFirebase = () => {
  signOut(auth)
    .then(() => {
      // Sign-out successful.
      console.log("Successfully sign-out!");
    })
    .catch((error) => {
      // An error happened.
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log("Error: ", errorCode, errorMessage);
    });
};

//Precios

const dbRef7 = collection(db, "Precios");
const dataPrecios = store.state.precios;

export const addPrecios = async () => {
  // await addDoc(dbRef3, ...dataWestnet);
  // console.log("Document written with ID: ", dbRef3.id);

  // Add the document to the database and get a reference to it
  let docRef = await addDoc(dbRef7, ...dataPrecios);

  // Get the ID of the new document
  const docId = docRef.id;
  // Update the document with the ID
  let docR = doc(dbRef7, docId);
  await updateDoc(docR, { id: docId });
  console.log("Document written with ID: ", docId);
};
export const getPrecios = async () => {
  const querySnapshot = await getDocs(collection(db, "Precios"));
  querySnapshot.forEach((doc) => {
    console.log(`${doc.id} => ${doc.data()}`);
  });
  const precios = querySnapshot.docs.map((doc) => doc.data());
  store.state.preciosget = precios;

  return precios;
};

//Update
export const updatePrecios = async (docId) => {
  try {
    let docRef = doc(dbRef7, docId);
    await updateDoc(docRef, ...dataPrecios);
  } catch (error) {
    console.error("Error updating document: ", error);
  }
};

//guardar varios documentos
export const addRouters = async () => {
  const batch = writeBatch(db);
  const mycollection = store.state.collection;
  const collectionRef = collection(db, mycollection );
  const documentsData = store.state.routers;

  documentsData.forEach((data) => {
    const documentRef = doc(collectionRef);
    const newDoc = { ...data, id: documentRef.id };
    batch.set(documentRef , newDoc);
  });

  batch
    .commit()
    .then(() => {
      console.log("Los documentos se crearon correctamente.");
    })
    .catch((error) => {
      console.error("Error al crear los documentos:", error);
    });
};